import { Paragraph } from 'docx';
import { IntlShape } from 'react-intl';

import { FORBIDDEN_FILENAME_CHARS } from './consts';

type SanitizeFileNameOptions = {
  input?: string;
  accents?: boolean; // replace accented letters with unaccented equivalents, defaults to true
  fallback?: string; // used if !input, defaults to 'untitled'
};

export function sanitizeFileName(options: SanitizeFileNameOptions): string {
  const { input, accents = true, fallback = 'Untitled' } = options;
  if (!input) return fallback;
  const accentMap: { [key: string]: string } = {
    À: 'A',
    Á: 'A',
    Â: 'A',
    Ã: 'A',
    Ä: 'A',
    Å: 'A',
    à: 'a',
    á: 'a',
    â: 'a',
    ã: 'a',
    ä: 'a',
    å: 'a',
    È: 'E',
    É: 'E',
    Ê: 'E',
    Ë: 'E',
    è: 'e',
    é: 'e',
    ê: 'e',
    ë: 'e',
    Ì: 'I',
    Í: 'I',
    Î: 'I',
    Ï: 'I',
    ì: 'i',
    í: 'i',
    î: 'i',
    ï: 'i',
    Ò: 'O',
    Ó: 'O',
    Ô: 'O',
    Õ: 'O',
    Ö: 'O',
    Ø: 'O',
    ò: 'o',
    ó: 'o',
    ô: 'o',
    õ: 'o',
    ö: 'o',
    ø: 'o',
    Ù: 'U',
    Ú: 'U',
    Û: 'U',
    Ü: 'U',
    ù: 'u',
    ú: 'u',
    û: 'u',
    ü: 'u',
    Ç: 'C',
    ç: 'c',
    Ñ: 'N',
    ñ: 'n',
    Ý: 'Y',
    ý: 'y',
    ÿ: 'y',
  };
  // Replace accented characters with their unaccented equivalents
  const noAccents = accents
    ? input
        .split('')
        .map((char) => accentMap[char] || char)
        .join('')
    : input;
  return noAccents.replace(FORBIDDEN_FILENAME_CHARS, '');
  // const regex = /[^a-zA-Z0-9-_. ]/g;
  // return noAccents.replace(regex, '');
}

export function datesToDocx(
  intl: IntlShape,
  start?: Date | null,
  end?: Date | null,
): Paragraph | null {
  if (start)
    return new Paragraph({
      text:
        intl.formatDate(start, {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        }) +
        (end
          ? ' - ' +
            intl.formatDate(end, {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            })
          : ''),
      style: 'date',
    });
  return null;
}
